import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

export const guestPropertyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Session hydration is synchronous in AuthService's browser constructor.
  // Do not render guest content on the server where localStorage is unavailable.
  if (!auth.isBrowser()) return false;
  if (auth.isLoggedIn()) return new RedirectCommand(router.createUrlTree(['/search']), { replaceUrl: true });
  auth.clearRedirectUrl();
  return true;
};

/** Legacy property links use the authenticated search flow and retain filters. */
export const exploreHomesGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  return router.createUrlTree(['/search'], { queryParams: route.queryParams });
};
